// Dependencies
import React, { Component, PropTypes, cloneElement } from 'react';
import { connect } from 'react-redux';
import { Paper, FlatButton } from 'material-ui';
import { getConfig } from '../../stores/config/config-actions';
import { updateUpgradeSource } from '../../stores/user/user-actions';
import { hydrateStores } from '../../utils/hydrate-stores';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import muiTheme from '../../utils/muiTheme';
import AppBar from '../app-bar/app-bar';
import SnackBarMessage from '../snackBarMessage';
import DownloadPopover from './downloadPopover';
import GlobalAlert from './global-alert-box';
import moment from 'moment';
import { toLaxTitleCase } from 'titlecase';

import Upgrade from '../upgrade';
import Beamer from '../beamer/beamer-container';
import HelpWidget from '../tc-ui/help-widget';
import ErrorsDisplay from './global-errors-display/global-errors-display-container';

import * as upgradeConstants from '../../stores/ui/components/upgrade/upgrade-constants';

import { upgradeResetAndClose } from '../../stores/ui/components/upgrade/upgrade-actions';
import { addSubscription, resetBillingError } from '../../stores/billing/billing-actions';
import { closeUpgrade } from '../../stores/ui/components/upgrade/upgrade-actions';
import RateDocIframe from '../contracting/dummy-account/rate-doc-iframe';
import Wall from '../wall/index';

class AppWindow extends Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    const { dispatch, history, config } = this.props;
    moment.locale(config.locale);
    dispatch(getConfig());
    hydrateStores(dispatch, history);
  }

  componentWillUpdate(nextProps) {
    const { dispatch, upgrade } = this.props;
    if (this.props.config.locale !== nextProps.config.locale) {
      moment.locale(nextProps.config.locale);
    }

    if (upgrade.isOpen !== nextProps.upgrade.isOpen && !nextProps.upgrade.isOpen) dispatch(resetBillingError());
    if (this.props.location.pathname !== nextProps.location.pathname) {
      document.title = `${toLaxTitleCase((nextProps.location.pathname || '').split('/').join(' '))} - TourConnect`;
    }
  }

  _updateUpgradeSource = (source) => {
    const { dispatch } = this.props;
    dispatch(updateUpgradeSource(source));
  };

  _logUpgradeClick = (source, type) => {
    const { dispatch } = this.props;
    // dispatch(logUpgradeClick(source, type));
  };

  triggerSnackBarMessage = (options) => {
    this.refs.snackBarMessage.triggerSnackBarMessage(options);
  };

  getUpgradeHeader = () => {
    const { upgrade, profile } = this.props;
    const { upgradeReason } = upgrade;

    switch (upgradeReason) {
      case upgradeConstants.PARTNER_FINDER_CONNECT:
        const { clickedCompany } = upgrade;
        return <span>Please upgrade your account to connect with <strong style={{ textDecoration: 'underline' }}>{clickedCompany}</strong>.</span>;
      default:
        return <span>Upgrade to unlock the power of TourConnect.</span>;
    }
  }

  onUpgrade = (selectedPlan, response) => {
    const { dispatch } = this.props;
    dispatch(addSubscription(selectedPlan.planId, response.id, response.card))
      .then(() => dispatch(resetBillingError()))
      .then(() => dispatch(closeUpgrade()))
      .catch(() => { });
  }

  render() {
    if (!this.props.user || !this.props.user.user.userID) return false;

    const { children, helpwidget, upgrade, walkthru, ...props } = this.props;
    const { lockedPartners } = this.props.user;
    const lockedPartnersBanner = (() => {
      if (lockedPartners < 1) return undefined;
      return (
        <Paper
          style={{
            marginTop: '1em',
            padding: '1em 1em 0.5em',
            textAlign: 'center',
            backgroundColor: 'rgba(255, 193, 7, 0.3)',
          }}
          variant="outlined"
        >
          <strong>
            {lockedPartners + 3} partners have accepted your Partner Requests and are ready to work with you!
            <br />
          </strong>
          <FlatButton
            secondary
            label="Go to Partner List to start working with them"
            onClick={() => window.location = `${
              process.env.NEW_SYSTEM_URL
            }/partner-management/partner-list/partner?jwt=${localStorage.getItem('jwt')}`}
          />
        </Paper>
      );
    })();
    const extraProps = {
      triggerSnackBarMessage: this.triggerSnackBarMessage,
      updateUpgradeSource: this._updateUpgradeSource,
      logUpgradeClick: this._logUpgradeClick,
      lockedPartnersBanner,
      ...props,
    };
    const upgradeHeader = upgrade.isOpen ?
      <h1 style={{ fontWeight: 300, fontSize: '21px', lineHeight: '36px', margin: 0, textAlign: 'center', paddingTop: '25px' }}>
        { this.getUpgradeHeader() }
      </h1> :
      null;
    return (
      <MuiThemeProvider muiTheme={muiTheme}>
        <div className="app-window" style={upgrade.isOpen ? { overflow: 'hidden' } : {}}>
          <AppBar ref="appBar" walkthru={walkthru} helpwidget={helpwidget} {...props} />
          {children ? cloneElement(children, extraProps) : undefined}
          <SnackBarMessage {...props} ref="snackBarMessage" open={props.open || false} />
          <DownloadPopover/>
          <GlobalAlert/>
          { upgrade.isOpen && <Upgrade
            dispatch={props.dispatch}
            stripePublicKey={process.env.STRIPE_PUBLIC_KEY}
            billing={props.billing}
            onUpgrade={this.onUpgrade}
            onClose={() => props.dispatch(upgradeResetAndClose()) }
            user={props.user}
            profile={props.profile}
            header={upgradeHeader}
            errorMessage={props.billing.errorMessage}
            isProcessing={props.billing.isLoading}
            upgradeReason={upgrade.upgradeReason}
          /> }
          <Beamer companyType={props.user.user.type === 'Supplier' ? 'supplier' : 'buyer'} isActive={helpwidget.isNewFeaturesActive} />
          {
            !props.user.forCC && (
              <HelpWidget
                companyType={props.user.user.type }
                acctCreationReason={props.user.company.acctCreationReason}
              />
            )
          }
          <ErrorsDisplay/>
          <Wall />
          <RateDocIframe/>
        </div>
      </MuiThemeProvider>
    );
  }
}

AppWindow.propTypes = {
  config: PropTypes.object,
  user: PropTypes.object,
  children: PropTypes.object,
  dispatch: PropTypes.func,
  history: PropTypes.object,
  location: PropTypes.object,
  routerState: PropTypes.object,
  profile: PropTypes.object,
  upgrade: PropTypes.object,
};

const select = state => {
  return {
    billing: state.billing.toJS(),
    user: state.user.toJS(),
    config: state.config.toJS(),
    connectionsStats: state.connectionsStats.toJS(),
    profile: state.profile.toJS(),
    upgrade: state.ui.upgrade.toJS(),
    helpwidget: state.ui.helpwidget.toJS(),
    walkthru: state.ui.walkthru.toJS(),
  };
};

export default connect(select)(AppWindow);



// WEBPACK FOOTER //
// ./src/app/components/containers/app-window.jsx